__turbopack_context__.v({
  "functionalityButton": "functionalityButton-module-scss-module__BS82ja__functionalityButton",
});
